import api from './api';
import { withMockFallback } from './mocks/withMockFallback';
import {
  getDetectionProfileMock,
  updateDetectionProfileMock,
} from './mocks/detectionProfileMock';

/**
 * Detection profile камеры (Part 4, разделы 6.2 и 6.3) — TARGET FROZEN.
 *
 * Контракт заморожен, backend может его ещё не иметь: на 404/501 сервис
 * отдаёт mock той же формы. Когда endpoint появится, меняется только этот
 * файл — UI не трогается.
 *
 * manual_features в PATCH — ПОЛНЫЙ authoritative набор фич, которые админ
 * держит включёнными вручную. Пересчёт required_by_rules и effective_enabled
 * делает backend; фронт его не повторяет.
 */

const profilePath = (cameraId) => `/admin/cameras/${cameraId}/detection-profile`;

export const getDetectionProfile = (cameraId) =>
  withMockFallback(
    () => api.get(profilePath(cameraId)).then((response) => response.data),
    () => getDetectionProfileMock(cameraId)
  );

export const updateDetectionProfile = (cameraId, payload) =>
  withMockFallback(
    () => api.patch(profilePath(cameraId), payload).then((response) => response.data),
    () => updateDetectionProfileMock(cameraId, payload)
  );
